import { destinationSearch } from "@/shell/destination-search";

const JOURNAL_STATUSES = ["all", "draft", "posted", "void"] as const;
type JournalStatusFilter = (typeof JOURNAL_STATUSES)[number];

export function journalStatus(value: unknown): JournalStatusFilter {
  return JOURNAL_STATUSES.find(status => status === value) ?? "all";
}

/** Carry only this journal query and the Console-owned launch context. */
export function journalSearch(previous: Record<string, unknown>, query: Record<string, unknown> = previous) {
  const filters: Record<string, string> = {};
  for (const key of ["account_id", "start_date", "end_date"]) {
    if (typeof query[key] === "string" && query[key]) filters[key] = query[key];
  }
  const status = journalStatus(query.status);
  if (status !== "all") filters.status = status;
  return destinationSearch(previous, filters);
}
